import React from 'react';
import PropTypes from 'prop-types';
import WIDGET_LABELS from '../../constants/widgetLabels';
import {
  Overlay,
  Panel,
  PanelHeader,
  WidgetLabel,
  CloseButton,
  Section,
  SectionLabel,
  GrowOptions,
  GrowButton,
  RemoveButton
} from './styled';

const GROW_OPTIONS = [1, 2, 3];
const VARIANT_OPTIONS = [
  { value: 'horizontal', label: 'Horizontal' },
  { value: 'vertical', label: 'Vertical' }
];
const WIDGETS_WITH_VARIANT = ['bySeverity'];

const WidgetDrawer = ({ widget, onClose, onUpdate, onRemove }) => {
  const currentGrow = widget.grow || 1;
  const currentVariant = widget.variant || 'horizontal';
  const label = WIDGET_LABELS[widget.id] || widget.id;
  const hasVariant = WIDGETS_WITH_VARIANT.includes(widget.id);

  return (
    <>
      <Overlay onClick={ onClose } />
      <Panel onClick={ e => e.stopPropagation() }>
        <PanelHeader>
          <WidgetLabel>{ label }</WidgetLabel>
          <CloseButton onClick={ onClose }>✕</CloseButton>
        </PanelHeader>

        <Section>
          <SectionLabel>Width</SectionLabel>
          <GrowOptions>
            {GROW_OPTIONS.map(value => (
              <GrowButton
                key={ value }
                $active={ currentGrow === value }
                onClick={ () => onUpdate({ grow: value }) }
              >
                { value }x
              </GrowButton>
            ))}
          </GrowOptions>
        </Section>

        {hasVariant && (
          <Section>
            <SectionLabel>Layout</SectionLabel>
            <GrowOptions>
              {VARIANT_OPTIONS.map(({ value, label: optLabel }) => (
                <GrowButton
                  key={ value }
                  $active={ currentVariant === value }
                  onClick={ () => onUpdate({ variant: value }) }
                >
                  { optLabel }
                </GrowButton>
              ))}
            </GrowOptions>
          </Section>
        )}

        <RemoveButton onClick={ onRemove }>Remove from dashboard</RemoveButton>
      </Panel>
    </>
  );
};

WidgetDrawer.propTypes = {
  widget: PropTypes.shape({
    id: PropTypes.string.isRequired,
    grow: PropTypes.number,
    variant: PropTypes.string
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
};

export default WidgetDrawer;
